import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { IncrementFor } from 'frontend-utils';

interface HotelBenchmarkInsightDesiredCompsetTdStarsSignature {
  Args: {
    value: number;
  };
}

export default class HotelBenchmarkInsightDesiredCompsetTdStars extends Component<HotelBenchmarkInsightDesiredCompsetTdStarsSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get numberOfEmptyStars() {
    return 5 - this.args.value;
  }

  <template>
    <div class="flex flex-row">
      <IncrementFor @times={{@value}}>
        <PrismIcon
          @name="star-filled"
          @size="extra-small"
          data-test-id="td-stars-star"
        />
      </IncrementFor>

      <IncrementFor @times={{this.numberOfEmptyStars}}>
        <PrismIcon
          @name="star-outline"
          @size="extra-small"
          data-test-id="td-stars-star-empty"
        />
      </IncrementFor>
    </div>
  </template>
}
